module.exports = __webpack_public_path__ + "static/northcoastlogo-0021fe2badb6fdfd1e45d1764df56c02.png";